module.exports = __webpack_public_path__ + "static/media/app-download-google_0.61764809.png";